import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Assets/style/ccp-datepicker.css';
import './i18n';
import './dayjs';
import './chartjs';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from "react-router-dom";
import {Toaster} from "react-hot-toast";
import AppRouter from "./Router/AppRouter";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://d4e52c83a23b1a014471dc6f968eb230@o427056.ingest.us.sentry.io/4511711063965697",
    sendDefaultPii: true,
    enabled: process.env.NODE_ENV !== 'development',
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
        'Network Error',
        /timeout of \d+ms exceeded/,
        'timeout exceeded',
    ],
});

const clarityId = import.meta.env.VITE_APP_CLARITY_PROJECT_ID;
if (clarityId && import.meta.env.MODE !== 'development') {
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window,document,"clarity","script",clarityId);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={AppRouter} />
      <Toaster />
  </React.StrictMode>
);

reportWebVitals();
